import { render } from "./PasswordResetRequest.vue?vue&type=template&id=b0d0e626&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=b0d0e626&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d0e626"]])

export default __exports__